import { render, staticRenderFns } from "./InternalTransfer.vue?vue&type=template&id=82e1c90e"
import script from "./InternalTransfer.vue?vue&type=script&lang=js"
export * from "./InternalTransfer.vue?vue&type=script&lang=js"
import style0 from "./InternalTransfer.vue?vue&type=style&index=0&id=82e1c90e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports